export default "__VITE_ASSET__CVNbmh0g__"